export const getParamString = (params) => Object.entries(params)
    .reduce((result, [key, value]) => {
    if (typeof value === 'string') {
        result.push(`${key}=${encodeURIComponent(value)}`);
    }
    return result;
}, [])
    .join('&');
export const openPopup = ({ url, params, }) => {
    const width = 550;
    const height = 420;
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    const left = Math.round(screenWidth / 2 - width / 2);
    const top = screenHeight > height ? Math.round(screenHeight / 2 - height / 2) : 0;
    window.open(`${url}?${getParamString(params)}`, '', `scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=${width},height=${height},left=${left},top=${top}`);
};
//# sourceMappingURL=utils.js.map